import React from 'react';

import { Divider } from '@repo/editor/src/components/utilities/styles';

import ContentWrapper from 'components/Landing/ContentWrapper/ContentWrapper';

const DividerSlice = ({ slice }) => (
  <ContentWrapper
    background={slice.primary.background}
    className="divider"
    customWidth={slice.primary.customWidth || '1440px'}
  >
    <Divider
      style={{
        marginTop: slice.primary.marginTop,
        marginBottom: slice.primary.marginBottom,
      }}
    />
  </ContentWrapper>
);

export default DividerSlice;
